import { render } from "./LinkageLoginProfileConfirm.vue?vue&type=template&id=02f9b60a&scoped=true&ts=true"
import script from "./LinkageLoginProfileConfirm.vue?vue&type=script&lang=ts"
export * from "./LinkageLoginProfileConfirm.vue?vue&type=script&lang=ts"

import "./LinkageLoginProfileConfirm.vue?vue&type=style&index=0&id=02f9b60a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1488180328/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02f9b60a"]])

export default __exports__